// Module
var code = "<div> <div class=\"rip-dialog-body-content\"> {{ message }} </div> </div> ";
// Exports
module.exports = code;